import { render } from "./UgmMachine.vue?vue&type=template&id=1b8a9b9c&scoped=true"
import script from "./UgmMachine.vue?vue&type=script&lang=js"
export * from "./UgmMachine.vue?vue&type=script&lang=js"

import "./UgmMachine.vue?vue&type=style&index=0&id=1b8a9b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a9b9c"]])

export default __exports__